import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal } from "./Reveal";

const faqs = [
  {
    q: "How much does Purpose Haul charge?",
    a: "Our standard full-service dispatch rate is 9% of gross load revenue for loads dispatched by Purpose Haul, subject to your signed service agreement.",
  },
  {
    q: "Do I have to accept every load?",
    a: "No. The carrier retains full control over whether to accept or reject any load opportunity we present.",
  },
  {
    q: "Do you guarantee a certain amount per week?",
    a: "No. Freight availability and rates vary by market, equipment, location, season, broker requirements, and other conditions.",
  },
  {
    q: "Who is Purpose Haul designed for?",
    a: "We primarily serve owner-operators and small carriers who want professional support managing routine dispatch activities.",
  },
];

export const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-28 sm:py-36 bg-[#101010] border-y border-white/10" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-4">
          <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-neutral-500 mb-4">
            Questions — Answered
          </p>
          <h2 className="font-display font-bold uppercase tracking-tight leading-none text-3xl sm:text-5xl">
            Frequently asked.
          </h2>
        </Reveal>

        <div className="lg:col-span-8">
          {faqs.map((f, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div className="border-b border-white/10" data-testid={`faq-item-${i}`}>
                <button
                  data-testid={`faq-question-${i}`}
                  onClick={() => setOpen(open === i ? -1 : i)}
                  className="w-full flex items-center justify-between gap-6 py-7 text-left group"
                >
                  <span className="font-display font-bold uppercase tracking-tight text-lg sm:text-xl group-hover:text-neutral-300 transition-colors duration-300">
                    {f.q}
                  </span>
                  <motion.span
                    animate={{ rotate: open === i ? 45 : 0 }}
                    transition={{ duration: 0.3 }}
                    className="shrink-0 text-neutral-400"
                  >
                    <Plus size={20} />
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {open === i && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="pb-7 text-neutral-400 leading-relaxed max-w-2xl" data-testid={`faq-answer-${i}`}>
                        {f.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
